module.exports = __webpack_public_path__ + "static/media/home-dark.9c97b729.svg";